module.exports = __webpack_public_path__ + "media/images/covers/Virtual-Boarding-School-Fair-2024-ef30b4fb7b85ac7759fe4611455b04cb.jpg";